import { render, staticRenderFns } from "./TrafficAnalysis.vue?vue&type=template&id=bd533b4a&"
import script from "./TrafficAnalysis.vue?vue&type=script&lang=js&"
export * from "./TrafficAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TrafficAnalysis.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports